import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const depositRoutesDictionary = moduleRouteDictionaryFactory(
  'deposit',
  'deposit',
  {
    list: 'list',
  },
);
